import { Link as RouterLink } from "react-router-dom";
import { categories } from "@/mocks/categories";

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200/70">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-16 md:py-20">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-10 md:gap-12">
          <div>
            <h4 className="text-sm font-semibold text-foreground-950 mb-5 pb-3 border-b border-background-300/60">
              <a href="#categories" className="hover:text-primary-500 transition-colors cursor-pointer">Kategorie</a>
            </h4>
            <ul className="flex flex-col gap-2.5">
              {categories.slice(0, 5).map((cat) => (
                <li key={cat.id}>
                  <a
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-sm text-foreground-600 hover:text-foreground-950 transition-colors cursor-pointer whitespace-nowrap"
                  >
                    {cat.namePl}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-950 mb-5 pb-3 border-b border-background-300/60">
              Poradniki
            </h4>
            <ul className="flex flex-col gap-2.5">
              <li>
                <RouterLink to="/co-to-jest-kakobuy-spreadsheet" className="text-sm text-foreground-600 hover:text-foreground-950 transition-colors cursor-pointer whitespace-nowrap">
                  Co to jest Spreadsheet?
                </RouterLink>
              </li>
              <li>
                <RouterLink to="/jak-zamawiac-kakobuy" className="text-sm text-foreground-600 hover:text-foreground-950 transition-colors cursor-pointer whitespace-nowrap">
                  Jak zamawiać?
                </RouterLink>
              </li>
              <li>
                <RouterLink to="/" className="text-sm text-foreground-600 hover:text-foreground-950 transition-colors cursor-pointer whitespace-nowrap">
                  Jak płacić?
                </RouterLink>
              </li>
              <li>
                <RouterLink to="/" className="text-sm text-foreground-600 hover:text-foreground-950 transition-colors cursor-pointer whitespace-nowrap">
                  Tabela rozmiarów
                </RouterLink>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-950 mb-5 pb-3 border-b border-background-300/60">
              Porównania
            </h4>
            <ul className="flex flex-col gap-2.5">
              <li>
                <RouterLink to="/kakobuy-vs-pandabuy" className="text-sm text-foreground-600 hover:text-foreground-950 transition-colors cursor-pointer whitespace-nowrap">
                  Kakobuy vs Pandabuy
                </RouterLink>
              </li>
              <li>
                <RouterLink to="/" className="text-sm text-foreground-600 hover:text-foreground-950 transition-colors cursor-pointer whitespace-nowrap">
                  Kakobuy vs CNFans
                </RouterLink>
              </li>
              <li>
                <RouterLink to="/" className="text-sm text-foreground-600 hover:text-foreground-950 transition-colors cursor-pointer whitespace-nowrap">
                  Kakobuy vs Sugargoo
                </RouterLink>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-950 mb-5 pb-3 border-b border-background-300/60">
              FAQ
            </h4>
            <ul className="flex flex-col gap-2.5">
              <li>
                <a href="#faq" className="text-sm text-foreground-600 hover:text-foreground-950 transition-colors cursor-pointer whitespace-nowrap">
                  Bezpieczeństwo
                </a>
              </li>
              <li>
                <a href="#faq" className="text-sm text-foreground-600 hover:text-foreground-950 transition-colors cursor-pointer whitespace-nowrap">
                  Zwroty
                </a>
              </li>
              <li>
                <a href="#faq" className="text-sm text-foreground-600 hover:text-foreground-950 transition-colors cursor-pointer whitespace-nowrap">
                  Czas dostawy
                </a>
              </li>
              <li>
                <a href="#faq" className="text-sm text-foreground-600 hover:text-foreground-950 transition-colors cursor-pointer whitespace-nowrap">
                  Kontakt
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-16 md:mt-20 pt-10 border-t border-background-300/60 flex flex-col md:flex-row items-start md:items-end justify-between gap-8">
          <div>
            <p className="text-5xl md:text-7xl font-heading font-extrabold text-foreground-950 leading-none">
              Kakobuy<br />Spreadsheet
            </p>
            <div className="w-10 h-0.5 bg-accent-500 mt-3"></div>
            <p className="text-xs text-foreground-500 mt-2">Polska Baza Produktów 2026</p>
          </div>

          <div className="flex flex-col items-start md:items-end gap-4">
            <p className="text-sm text-foreground-500">
              {new Date().getFullYear()} kakobuyspreadsheet.watch — Wszelkie prawa zastrzeżone.
            </p>
            <div className="flex items-center gap-4">
              <a href="#" className="w-8 h-8 flex items-center justify-center text-foreground-500 hover:text-foreground-950 transition-colors cursor-pointer">
                <i className="ri-instagram-line text-lg"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center text-foreground-500 hover:text-foreground-950 transition-colors cursor-pointer">
                <i className="ri-tiktok-line text-lg"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center text-foreground-500 hover:text-foreground-950 transition-colors cursor-pointer">
                <i className="ri-twitter-x-line text-lg"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}